var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report"},[_c('div',{staticClass:"report-email"},[_c('img',{attrs:{"src":require("@/assets/images/email.png"),"alt":""}})]),_c('div',{staticClass:"report-address"},[_vm._v(" 举报邮箱：jubao@luotuoguihua.com ")])])
}]

export { render, staticRenderFns }